(function () {
    "use strict";

    var Accordion = function (el, options) {
        this.settings = options;
        this.$el = $(el);
        this.$items = this.$el.find("> .accordion-item, > span > .accordion-item");
        this.$titles = this.$items.find("> .accordion-title");

        // If accordion is within a align-height container
        // It needs to calculate its maxHeight on resize
        // For Tena.Alignment to set the right height
        this.shouldSetMaxHeight = this.$el.closest(".align-height").length;
        this.prependArrow = this.$el.hasClass("accordion-prepend-arrow");
        this.keepItemsOpen = this.$el.hasClass("accordion-keep-open");

        this.init();
    };

    Accordion.prototype = {
        init: function () {
            var prototypeAccordion = this,
                $firstItem = prototypeAccordion.$items.first();

            if ($firstItem.find("> .accordion-content").css("display") === "none") {
                $firstItem.addClass("accordion-collapsed");
            }

            $firstItem.attr("class", function (_i, c) {
                return c.replace(/(^|\s)accordion-collapsed-\S+/g, "");
            });

            prototypeAccordion.$titles.each(function () {
                var $icon = $(this).find("i"),
                    arrow = '<i class="icon-arrow-down"></i>';

                if (!$icon.length && !prototypeAccordion.$el.hasClass("accordion-no-icon")) {
                    if (prototypeAccordion.prependArrow) {
                        $(this)
                            .wrapInner('<span class="accordion-title-content"></span>')
                            .prepend(arrow);
                    } else {
                        $(this).prepend(arrow);
                    }
                }
            });

            if (!prototypeAccordion.$el.hasClass("accordion-collapsed") &&
                !$firstItem.hasClass("accordion-collapsed") &&
                !$firstItem.hasClass("accordion-expanded")
            ) {
                prototypeAccordion.expand(prototypeAccordion.$items.first());
            }

            prototypeAccordion.$items.each(function () {
                var $item = $(this);
                if (!$item.hasClass("accordion-expanded")) {
                    $item.addClass("accordion-collapsed");
                }
            });

            prototypeAccordion.bindEvents();

            if (prototypeAccordion.shouldSetMaxHeight) {
                prototypeAccordion.$el.addClass("dynamic-height");
            }
        },

        bindEvents: function () {
            var eventAccordion = this;

            eventAccordion.$el.on(
                "click",
                "> .accordion-item > .accordion-title, > span > .accordion-item .accordion-title",
                function (e) {
                    var $this = $(this),
                        // $item = $this.parent();
                        $item = $this.closest(".accordion-item"),
                        disableClass = $item.attr("data-accordion-disable");

                    // Disable click on specific element
                    // Example:
                    // <div class="accordion-item" data-accordion-disable="field-checkbox-container">
                    if (disableClass) {
                        if ($(e.target).hasClass(disableClass) || $(e.target).parents()
                            .hasClass(disableClass)) {
                            return;
                        }
                    }

                    if ($item.hasClass("accordion-inactive")) return;
                    if ($item.hasClass("accordion-expanded")) {
                        eventAccordion.contract($item);
                    } else {
                        eventAccordion.expand($item);
                    }
                    return false;
                }
            );

            eventAccordion.$el.find(".js-accordion-continue").on("click", function () {
                FormAccordionContinueButton(eventAccordion, $(this));

            });

            if (eventAccordion.shouldSetMaxHeight) {
                $(window).on("resize", function () {
                    eventAccordion.setMaxHeight();
                });

                eventAccordion.setMaxHeight();
            }
        },

        setMaxHeight: function () {
            var maxHeight = 0,
                maxHeightAccordion = this,
                $currentItem = maxHeightAccordion.$items.filter(".accordion-expanded");

            $currentItem.removeClass("accordion-expanded");

            maxHeightAccordion.$items.each(function () {
                var $item = $(this);
                $item.addClass("accordion-expanded");
                if (maxHeightAccordion.$el.outerHeight(true) > maxHeight) {
                    maxHeight = maxHeightAccordion.$el.outerHeight(true);
                }
                $item.removeClass("accordion-expanded");
            });

            $currentItem.addClass("accordion-expanded");
            maxHeightAccordion.$el.attr("data-dynamic-height", maxHeight);
        },

        expand: function ($item) {
            var $content = $item.find("> .accordion-content"),
                maxHeightAccordion = this,
                height,
                $icon = $item.find("> .accordion-title i"),
                scrollTop = maxHeightAccordion.getScrollPosition($item);

            if (!maxHeightAccordion.keepItemsOpen) {
                maxHeightAccordion.$items.filter(".accordion-expanded").each(function () {
                    maxHeightAccordion.contract($(this));
                });
            }

            $icon.removeClass("icon-arrow-down").addClass("icon-arrow-up");
            $item.addClass("accordion-expanded").removeClass("accordion-collapsed");
            height = $content.height();

            if (scrollTop) {
                $(document).scrollTop(scrollTop);
            }

            $content
                .css({
                    height: 0,
                    opacity: 0
                })
                .animate({
                    height: height,
                    opacity: 1
                },
                    function () {
                        $content.css({ height: "" });
                    }
                );

            $.event.trigger("accordion.changed", {
                show: $item
            });
        },

        contract: function ($item, $nextItem) {
            var $content = $item.find("> .accordion-content"),
                $icon = $item.find("> .accordion-title i"),
                contractAccordion = this;

            $content
                .css({
                    height: $content.height()
                })
                .animate({
                    height: 0,
                    opacity: 0
                },
                    function () {
                        $content.css({ height: "" });
                        $icon.removeClass("icon-arrow-up").addClass("icon-arrow-down");
                        $item.removeClass("accordion-expanded").addClass("accordion-collapsed");
                    }
                )
                .delay();

            if ($nextItem) {
                $content.promise().done(function () {
                    contractAccordion.expand($nextItem);
                });
            }
        },

        getScrollPosition: function ($item) {
            var scrollAccordion = this,
                $current = scrollAccordion.$items.filter(".accordion-expanded"),
                currentHeight = $current.find("> .accordion-content").height(),
                currentIndex = scrollAccordion.$items.index($current),
                $visibleItems = scrollAccordion.$items.not('.hidden'),
                itemIndex = $visibleItems.index($item),
                $itemBefore = $visibleItems.eq(itemIndex - 1),

            scrollPos = 0,
                currentScrollPos = $(window).scrollTop();
          
            const scrollPosTopOffset = 70;
            if ($item.offset().top === "undefined") return scrollPos;

            if (itemIndex > currentIndex) {
                scrollPos = $item.offset().top - currentHeight - scrollPosTopOffset;
            } else {
                scrollPos = $item.offset().top - scrollPosTopOffset;
            }

            if (currentScrollPos < scrollPos) {
                scrollPos = false;
            }

            if (scrollPos && itemIndex > 0 && $itemBefore.length) {
                scrollPos = $itemBefore.offset().top - scrollPosTopOffset;
            }

            return scrollPos;
        }
    };

    $.fn.accordion = function (options) {
        var args = Array.prototype.slice.call(arguments, 1),
            $this,
            data;

        return this.each(function () {
            $this = $(this);
            data = $this.data("accordion");

            if (!data) {
                data = new Accordion(this, options)
                $this.data("accordion", (data));
            }
            if (typeof options === "string") {
                data[options](args);
            }
        });
    };

    $.fn.accordion.Constructor = Accordion;

    $(".accordion").accordion();

})(jQuery);
 